import { useEffect, useState } from "react";
import { CalendarPlus, Copy, RefreshCw } from "lucide-react";
import { apiFetch } from "@/lib/api";
import { toast } from "sonner";

export const SubscribeCard = () => {
  const [feed, setFeed] = useState(null);

  useEffect(() => {
    apiFetch("/me/feed").then(setFeed).catch(() => {});
  }, []);

  if (!feed) return null;

  const copy = () => {
    navigator.clipboard?.writeText(feed.url);
    toast.success("Feed link copied");
  };

  const reset = async () => {
    try {
      setFeed(await apiFetch("/me/feed/reset", { method: "POST" }));
      toast.success("New private link created — the old one stopped working");
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <section className="mt-10 rounded-2xl border border-neutral-200 p-6" data-testid="subscribe-card">
      <h2 className="flex items-center gap-2 text-xl font-bold tracking-tight text-neutral-900">
        <CalendarPlus className="h-5 w-5 text-[#4D7C0F]" /> Keep this calendar on your phone
      </h2>
      <p className="mt-1 text-sm text-neutral-500">
        Subscribe once and every Portland tech event stays in sync in Google, Apple or Outlook Calendar.
      </p>

      <div className="mt-4 flex flex-wrap items-center gap-2">
        <input
          readOnly
          value={feed.url}
          data-testid="feed-url"
          onFocus={(e) => e.target.select()}
          className="min-w-[240px] flex-1 rounded-full border border-neutral-300 bg-neutral-50 px-4 py-2.5 text-xs text-neutral-700 outline-none"
        />
        <button
          onClick={copy}
          data-testid="feed-copy"
          className="flex items-center gap-1.5 rounded-full bg-neutral-900 px-4 py-2.5 text-sm font-bold text-white transition-colors duration-200 hover:bg-neutral-700"
        >
          <Copy className="h-4 w-4" /> Copy link
        </button>
        <a
          href={feed.webcal}
          data-testid="feed-subscribe"
          className="rounded-full bg-[#B8FF2E] px-4 py-2.5 text-sm font-bold text-[#14210A] transition-colors duration-200 hover:bg-[#A2E80B]"
        >
          Subscribe now
        </a>
        <button
          onClick={reset}
          data-testid="feed-reset"
          title="Create a new private link"
          className="grid h-10 w-10 place-items-center rounded-full border border-neutral-300 transition-colors duration-200 hover:bg-neutral-50"
        >
          <RefreshCw className="h-4 w-4 text-neutral-600" />
        </button>
      </div>
      <p className="mt-3 text-xs text-neutral-400">
        This link is private to you — reset it if you ever share it by accident.
      </p>
    </section>
  );
};
